export const Icons = {
    home: 'home',
    companies: 'building',
    calendar: 'calendar',
    agreements: 'thumbs-up',
    notifications: 'comment',
    terms: 'calendar',
    support: 'comment',
    signOut: 'sign-out'
}